import axios from 'axios';

import routes from 'app/routes';

export default {
  updateGoals: (memberId, values, callback) => {
    axios
      .put(routes.api.members.profile.updateAiProgramGoals(memberId), { data: values })
      .then(() => {
        callback();
      });
  },

};
